/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const MemoryStoreVisibility = {
  Private: "private",
  Workspace: "workspace",
} as const;
export type MemoryStoreVisibility = ClosedEnum<typeof MemoryStoreVisibility>;

/** @internal */
export const MemoryStoreVisibility$inboundSchema: z.ZodNativeEnum<
  typeof MemoryStoreVisibility
> = z.nativeEnum(MemoryStoreVisibility);
/** @internal */
export const MemoryStoreVisibility$outboundSchema: z.ZodNativeEnum<
  typeof MemoryStoreVisibility
> = MemoryStoreVisibility$inboundSchema;
